import { Select, DateTimePicker, RadioGroup } from "../form_components/Input";
import Button from "../ui/Button";
import { useCallback, useEffect, useMemo, useState } from "react";
import { MapPin, Server, Clock } from "lucide-react";
import React from "react";
import { useRegions } from "../../context/RegionsContext";

export const VideoFilter = ({
  systems,
  isLoading,
  onFiltersApplied,
  setShowPlaylist,
}) => {
  const [filters, setFilters] = useState({
    // siteId: "1",
    systemId: "1",
    sensorId: "1",
    date: "2025-10-05",
    hour: "18",
  });
  const [errors, setErrors] = useState({});
  const [isPageLoading, setIsPageLoading] = useState(false);
  const { selectedRegion, getSystemsBySite } = useRegions();
  // const [systems, setSystems] = useState([]);
  const [systemError, setSystemError] = useState(null);

  // useEffect(() => {
  //   if (filters.siteId) {
  //     const loadSystems = async () => {
  //       try {
  //         setSystemError(null);
  //         const systemsData = await getSystemsBySite(filters.siteId);
  //         setSystems(systemsData || []);
  //       } catch (err) {
  //         setSystemError(err.message);
  //         console.error("Failed to load systems:", err);
  //         setSystems([]);
  //       }
  //     };
  //     loadSystems();
  //   } else {
  //     setSystems([]);
  //   }
  // }, [filters.siteId, getSystemsBySite]);

  const hours = Array.from({ length: 24 }, (_, i) => ({
    value: i.toString().padStart(2, "0"),
    label: `${i.toString().padStart(2, "0")}:00`,
  }));

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    if (errors[key]) {
      setErrors((prev) => ({ ...prev, [key]: "" }));
    }
  };

  const validateFilters = () => {
    const newErrors = {};
    // if (!filters.siteId) newErrors.siteId = "Please select a site";
    if (!filters.systemId)
      newErrors.systemId = "Please select a system";
    if (filters.siteId && !filters.date)
      newErrors.date = "Please select a date";
    if (filters.date && !filters.hour) newErrors.hour = "Please select an hour";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleApply = () => {
    if (validateFilters()) {
      setIsPageLoading(true);
      setTimeout(() => {
       
        if (onFiltersApplied) {
          onFiltersApplied(filters);
          setShowPlaylist(true);
        }
        setIsPageLoading(false);
      }, 500);
    }
  };

  const handleReset = () => {
    setFilters({ siteId: "", systemId: "", componentId: "1", date: "", hour: "" });
    setErrors({});
    // setSystems([]);
    if (onFiltersApplied) {
      onFiltersApplied(null);
    }
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <div className="bg-white h-full flex flex-col">
      <div className="flex-1 overflow-y-auto p-4">
        <div className="space-y-3">
          <Select
            label="System / Intersection"
            value={filters.systemId}
            onChange={(value) => handleFilterChange("systemId", value)}
            options={systems}
            optionValue="system_id"
            renderOption={(system) =>
              `System ${system.system_id},${system.street_name}`
            }
            placeholder="Select a system"
            error={errors.systemId}
            required
            icon={MapPin}
            disabled={isLoading}
          />

          {/* {systems.length > 0 && ( */}
          {/*   <Select */}
          {/*     label="System" */}
          {/*     value={filters.systemId} */}
          {/*     onChange={(value) => handleFilterChange("systemId", value)} */}
          {/*     options={systems} */}
          {/*     optionValue="system_id" */}
          {/*     placeholder="Select a system" */}
          {/*     renderOption={(system) => */}
          {/*       `${system.system_id}` */}
          {/*     } */}
          {/*     error={errors.systemId} */}
          {/*     required */}
          {/*     icon={Server} */}
          {/*     disabled={isLoading || !filters.siteId} */}
          {/*   /> */}
          {/* )} */}

          <RadioGroup
            label="Component"
            options={[
              { value: "1", label: "Camera" },
              { value: "2", label: "LiDAR" },
              { value: "3", label: "RADAR" },
            ]}
            selected={filters.componentId}
            direction="horizontal"
            onChange={(value) => handleFilterChange("componentId", value)}
            // disabled={true}
          />

          <div className="border-t border-gray-200 my-3"></div>

          <DateTimePicker
            date={filters.date}
            onDateChange={(value) => handleFilterChange("date", value)}
            mode="date"
            error={errors.date}
            required
            minDate="2025-10-01"
            maxDate="2025-10-07"
          />

          <Select
            label="Hour"
            value={filters.hour}
            onChange={(value) => handleFilterChange("hour", value)}
            options={hours}
            placeholder="Select hour"
            error={errors.hour}
            required
            icon={Clock}
            disabled={isLoading}
          />
        </div>
      </div>

      <div className="p-4 border-t bg-gray-50">
        <div className="flex gap-2">
          <Button
            onClick={handleApply}
            className="flex-1"
            disabled={isPageLoading}
          >
            {isPageLoading ? "Loading..." : "Apply"}
          </Button>
          <Button
            onClick={handleReset}
            variant="outline"
            className="flex-1"
            disabled={isPageLoading}
          >
            Reset
          </Button>
        </div>
      </div>
    </div>
  );
};
